(function () {
  'use strict';

  var carousels = document.querySelectorAll('[data-carousel]');

  carousels.forEach(function (el) {
    var track = el.querySelector('.carousel-track');
    var slides = track.querySelectorAll('.hero-slide');
    var dots = el.querySelectorAll('.carousel-dot');
    var interval = parseInt(el.dataset.interval, 10) || 5000;
    var autoplayEnabled = el.dataset.autoplay !== 'false';
    var current = 0;
    var count = slides.length;
    var timer = null;

    function goTo(index) {
      current = ((index % count) + count) % count;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function (d, i) {
        d.classList.toggle('active', i === current);
      });
    }

    function startAutoplay() {
      if (!autoplayEnabled) return;
      if (timer) clearInterval(timer);
      timer = setInterval(function () {
        goTo(current + 1);
      }, interval);
    }

    function stopAutoplay() {
      if (timer) clearInterval(timer);
    }

    // Dot click navigation
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        startAutoplay();
      });
    });

    // Pause on hover
    el.addEventListener('mouseenter', function () {
      stopAutoplay();
    });

    el.addEventListener('mouseleave', function () {
      startAutoplay();
    });

    // Keyboard navigation
    el.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        goTo(current - 1);
        startAutoplay();
      } else if (e.key === 'ArrowRight') {
        goTo(current + 1);
        startAutoplay();
      }
    });

    // Touch swipe
    var touchStartX = 0;
    var touchStartY = 0;
    var swipeHandled = false;

    el.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      swipeHandled = false;
      stopAutoplay();
    }, { passive: true });

    el.addEventListener('touchend', function (e) {
      if (swipeHandled) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
        goTo(dx < 0 ? current + 1 : current - 1);
        swipeHandled = true;
      }
      startAutoplay();
    }, { passive: true });

    // Initialize
    startAutoplay();
  });
})();
